jQuery(function ($) {
  const slicesSwiper = new Swiper(".js-slices-carousel", {
    loop: false,
    slidesPerView: 1.2,
    speed: 1000,
    allowTouchMove: true,
    spaceBetween: 10,
    breakpoints: {
      821: {
        slidesPerView: 3,
      },
    },
  });
})